import { z } from 'zod';

export const HcpSearchResultModel = z.object({
  hcpIdentifier: z.string(),
  name: z.string(),
  location: z.string().optional(),
  specialty: z.string().optional(),
  email: z.string().nullable(),
  phone: z.string().nullish(),
  firstName: z.string().optional(),
  lastName: z.string().optional(),
  middleName: z.string().optional(),
  primaryLocation: z
    .object({
      lat: z.number(),
      lon: z.number(),
    })
    .nullable()
    .optional(),
  primaryAffiliationName: z.string().optional(),
  usersEmails: z.array(z.string()).optional(),
  recommendedUserEmails: z.array(z.string()).optional(),
  distance: z.number().nullish(),
  profileUrl: z.string().nullish(),
});

export type HcpSearchResult = z.infer<typeof HcpSearchResultModel>;

export const HCPResultV2ModelSchema = z.object({
  id: z.union([z.number(), z.string()]),
  name: z.string(),
  profileUrl: z.string().nullish(),
  location: z.string().nullish(),
  specialty: z.string().nullish(),
  email: z.string().nullable(),
  phone: z.string().nullish(),
  primaryLocation: z
    .object({
      lat: z.number(),
      lon: z.number(),
    })
    .nullable()
    .optional(),
  primaryAffiliation: z.string().nullish(),
  distance: z.number().nullish(),
});
export type HCPResultV2 = z.infer<typeof HCPResultV2ModelSchema>;
